// extracted by mini-css-extract-plugin
export default {"select":"HW12_select__bQHE9","text":"HW12_text__ZDkfO"};